import { Container } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Header from "components/common/Header";
import React from "react";

const useStyles = makeStyles((theme) => ({
  layout: {
    minHeight: "100vh",
    display: "flex",
    flexDirection: "column",
    backgroundColor: theme.palette.background.main,
    width: `calc(100%)`,
  },
  main: {
    backgroundColor: theme.palette.background.default,
    display: "flex",
    flex: 1,
  },
  container: {},
}));

export default function LayoutNavbar({ children, title = "" }) {
  const classes = useStyles();
  return (
    <div className={classes.layout}>
      <Header hideMenubar title={title} />
      <main className={classes.main}>
        <Container maxWidth="lg" className={classes.container}>
          {children}
        </Container>
      </main>
    </div>
  );
}
